export const CodicePersonalizzazione = 'CodicePersonalizzazione'
export const BarcodeClientiTipo = 'BarcodeClientiTipo'
export const Barcode12Atelier98 = 'Barcode12Atelier98'
export const EAN13Atelier98 = 'EAN13Atelier98'
export const Barcode14Tipo = 'Barcode14Tipo'
export const BarcodeGrigliaVentilazione = 'BarcodeGrigliaVentilazione'
export const Barcode13Come12 = 'Barcode13Come12'

export const CodicePersonalizzazione_Scout = 'scout'
export const CodicePersonalizzazione_Fabi = 'fabi'
export const CodicePersonalizzazione_Marilli = 'marilli'
export const BarcodeClientiTipo_Tek = 'tek'
export const BarcodeClientiTipo_Cuf = 'cuf'
export const BarcodeClientiTipo_Mav = 'mav'
export const BarcodeClientiTipo_Cuf911 = 'cuf911'
export const BarcodeClientiTipo_In911 = 'in2011'
export const BarcodeClientiTipo_AVI5 = 'avi5'
export const BarcodeClientiTipo_OLI6 = 'oli6'
export const Barcode12Atelier98_Si = 'si'
export const Barcode12Atelier98_No = 'no'
export const Barcode12Atelier98_Sweda = 'swedamaster'
export const Barcode12Atelier98_Siepuri = 'si e puri'
export const Barcode13Come12_No = 'no'
export const EAN13Atelier98_Nara = 'nara'
export const EAN13Atelier98_Siepuri = 'si e puri'
export const EAN13Atelier98_13come8 = '13come8'
export const Barcode14Tipo_Mav = 'mav'
export const BarcodeGrigliaVentilazione_No = 'no'
